import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'age', 'sex', 'height', 'heightUnit', 'weight', 'weightUnit', 'activity',
    'bmr', 'tdee', 'cut', 'maintenance', 'leanBulk', 'bulk'
  ]

  connect() {
    this.calculate()
  }

  calculate() {
    const age = parseFloat(this.ageTarget.value) || 30
    const sex = this.sexTargets.find((r) => r.checked)?.value || 'male'
    let height = parseFloat(this.heightTarget.value) || 175
    const heightUnit = this.heightUnitTarget.value
    let weight = parseFloat(this.weightTarget.value) || 75
    const weightUnit = this.weightUnitTarget.value
    const activityMultiplier = parseFloat(this.activityTarget.value) || 1.55

    // Convert height to cm if in inches
    if (heightUnit === 'in') {
      height *= 2.54
    }

    // Convert weight to kg if in lbs
    if (weightUnit === 'lbs') {
      weight /= 2.205
    }

    // Calculate BMR using Mifflin-St Jeor formula
    // Men: (10 x weight) + (6.25 x height) - (5 x age) + 5
    // Women: (10 x weight) + (6.25 x height) - (5 x age) - 161
    let bmr
    if (sex === 'male') {
      bmr = (10 * weight) + (6.25 * height) - (5 * age) + 5
    } else {
      bmr = (10 * weight) + (6.25 * height) - (5 * age) - 161
    }

    // Calculate TDEE
    const tdee = bmr * activityMultiplier

    // Calculate goal calories
    const cut = tdee - 500 // Aggressive cut: -500 kcal
    const maintenance = tdee // Maintenance
    const leanBulk = tdee + 300 // Lean bulk: +300 kcal
    const bulk = tdee + 500 // Bulk: +500 kcal

    // Update display
    this.bmrTarget.textContent = this.formatNumber(Math.round(bmr))
    this.tdeeTarget.textContent = this.formatNumber(Math.round(tdee))
    this.cutTarget.textContent = this.formatNumber(Math.round(cut))
    this.maintenanceTarget.textContent = this.formatNumber(Math.round(maintenance))
    this.leanBulkTarget.textContent = this.formatNumber(Math.round(leanBulk))
    this.bulkTarget.textContent = this.formatNumber(Math.round(bulk))
  }

  formatNumber(num) {
    return num.toLocaleString('en-US')
  }
}
